'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import { WizardPanel } from '@repo/ui/WizardPanel'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { AlertIcon } from '@repo/ui/AlertIcon'
import { SuccessIcon } from '@repo/ui/SuccessIcon'
import { EditIcon } from '@repo/ui/EditIcon'
import { DeleteIcon } from '@repo/ui/DeleteIcon'
import MUIIconButton from '@mui/material/IconButton'
import MUITooltip from '@mui/material/Tooltip'

export const COISPartyCard = ({ parties, partyId, editParty, deleteParty }) => {
  const partyState = parties?.[partyId]
  if (!partyState) return <div data-testid="COISPartyCard" />

  return (
    <WizardPanel
      key={partyId}
      data-testid="COISPartyCard"
      onClick={() => editParty(partyId)}
      sx={{ cursor: 'pointer' }}
    >
      <MUIStack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ cursor: 'pointer', borderRadius: '4px' }}
      >
        <MUIStack direction="column" alignItems="flex-end">
          <WizardIconTitle
            variant="h6"
            title={partyState.displayName || 'New party'}
            sx={{ pointerEvents: 'none', mb: '7px' }}
          />

          {partyState?.conflicts ? (
            <MUIStack direction="row" alignItems="center" gap={2}>
              {partyState.conflicts.length > 0 ? <AlertIcon sx={{ width: '18px', height: '18px' }} /> : null}
              {partyState.conflicts.length === 0 ? <SuccessIcon sx={{ width: '18px', height: '18px' }} /> : null}
              <MUITypography variant="body2" sx={{ color: 'text.primary', mb: 0, pointerEvents: 'none' }} noWrap>
                {`${partyState.conflicts.length} possible conflict${partyState.conflicts.length === 1 ? '' : 's'} found`}
              </MUITypography>
            </MUIStack>
          ) : null}
        </MUIStack>

        <MUIStack direction="row" alignItems="center">
          <MUITooltip title="Edit" placement="top" arrow>
            <MUIIconButton onClick={() => editParty(partyId)} sx={{ padding: '12px' }}>
              <EditIcon sx={{ fontSize: '20px', width: '20px', height: '20px' }} />
            </MUIIconButton>
          </MUITooltip>

          <MUITooltip title="Delete" placement="top" arrow>
            <MUIIconButton onClick={(e) => deleteParty(e, partyId)} sx={{ padding: '12px' }}>
              <DeleteIcon sx={{ fontSize: '20px', width: '20px', height: '20px' }} />
            </MUIIconButton>
          </MUITooltip>
        </MUIStack>
      </MUIStack>
    </WizardPanel>
  )
}

COISPartyCard.propTypes = {
  parties: PropTypes.object,
  partyId: PropTypes.any,
  editParty: PropTypes.func,
  deleteParty: PropTypes.func
}
